module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "competition"
  }, [_c('div', {
    staticClass: "default__bg"
  }), _vm._v(" "), _c('sk-container', [(_vm.loading) ? _c('div', {
    staticClass: "loading"
  }, [_c('sk-progress-circular', {
    attrs: {
      "indeterminate": "",
      "size": "100",
      "width": 2,
      "primary": ""
    }
  })], 1) : [_c('sk-panel', [_c('sk-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [(_vm.movie && _vm.comp.use_movie_poster == '0') ? _c('sk-flex', {
    attrs: {
      "xs5": "",
      "md3": ""
    }
  }, [_c('div', {
    staticClass: "movie-detail__poster",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.dialogActive = true
      }
    }
  }, [_c('div', {
    staticClass: "movie-detail__poster-img"
  }, [_c('img', {
    staticClass: "img-responsive",
    attrs: {
      "src": _vm.movie.poster,
      "alt": ""
    }
  })]), _vm._v(" "), (!_vm.$breakpoints.xs) ? _c('sk-icon', {
    staticClass: "movie-detail__poster-play",
    attrs: {
      "play": ""
    }
  }) : _vm._e(), _vm._v(" "), _c('sk-video', {
    staticClass: "dialog-video",
    attrs: {
      "content": _vm.movie.youtube_id
    },
    model: {
      value: (_vm.dialogActive),
      callback: function($$v) {
        _vm.dialogActive = $$v
      },
      expression: "dialogActive"
    }
  })], 1)]) : ((!_vm.comp.use_movie_poster || _vm.comp.use_movie_poster == '0') && _vm.comp.poster_image) ? _c('sk-flex', {
    attrs: {
      "xs5": "",
      "md3": ""
    }
  }, [_c('div', {
    staticClass: "movie-detail__poster movie-detail__poster-img--no-trailer"
  }, [_c('div', {
    staticClass: "movie-detail__poster-img"
  }, [_c('img', {
    staticClass: "img-responsive-height",
    attrs: {
      "src": _vm.comp.poster_image.url,
      "alt": ""
    }
  })])])]) : _vm._e(), _vm._v(" "), (!_vm.$breakpoints.xs) ? _c('sk-flex', {
    attrs: {
      "xs7": "",
      "md9": ""
    }
  }, [_c('h1', [_vm._v(_vm._s(_vm.comp.title))]), _vm._v(" "), _c('p', {
    domProps: {
      "innerHTML": _vm._s(_vm.comp.detail)
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "promo__content-btns"
  }, [(!_vm.comp.button_link && !_vm.comp.button_text) ? _c('div', {
    staticClass: "promo__content-btns"
  }, [(_vm.movie) ? _c('sk-button', {
    attrs: {
      "primary": "",
      "router": "",
      "to": {
        name: 'Movie Details',
        params: {
          id: _vm.movie.id
        }
      }
    }
  }, [_vm._v("Book to Win\n                                ")]) : _vm._e()], 1) : _c('div', {
    staticClass: "promo__content-btns"
  }, [_c('sk-button', {
    attrs: {
      "primary": "",
      "tag": "a",
      "href": _vm.comp.button_link
    }
  }, [_vm._v(_vm._s(_vm.comp.button_text) + "\n                                ")])], 1), _vm._v(" "), _c('span', [_vm._v(" ")]), _vm._v(" "), ((_vm.comp.button_2_link || _vm.comp.button_2_text)) ? _c('div', {
    staticClass: "promo__content-btns"
  }, [_c('sk-button', {
    attrs: {
      "secondary": "",
      "tag": "a",
      "href": _vm.comp.button_2_link
    }
  }, [_vm._v(_vm._s(_vm.comp.button_2_text) + "\n                                ")])], 1) : _vm._e()])]) : [_c('sk-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('h1', [_vm._v(_vm._s(_vm.comp.title))])]), _vm._v(" "), _c('sk-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('p', {
    domProps: {
      "innerHTML": _vm._s(_vm.comp.detail)
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "promo__content-btns"
  }, [(!_vm.comp.button_link && !_vm.comp.button_text) ? _c('div', {
    staticClass: "promo__content-btns"
  }, [(_vm.movie) ? _c('sk-button', {
    attrs: {
      "primary": "",
      "router": "",
      "to": {
        name: 'Movie Details',
        params: {
          id: _vm.movie.id
        }
      }
    }
  }, [_vm._v("Book to Win\n                                    ")]) : _vm._e()], 1) : _c('div', {
    staticClass: "promo__content-btns"
  }, [_c('sk-button', {
    attrs: {
      "primary": "",
      "tag": "a",
      "href": _vm.comp.button_link
    }
  }, [_vm._v(_vm._s(_vm.comp.button_text) + "\n                                    ")])], 1), _vm._v(" "), _c('span', [_vm._v(" ")]), _vm._v(" "), ((_vm.comp.button_2_link || _vm.comp.button_2_text)) ? _c('div', {
    staticClass: "promo__content-btns"
  }, [_c('sk-button', {
    attrs: {
      "secondary": "",
      "tag": "a",
      "href": _vm.comp.button_2_link
    }
  }, [_vm._v(_vm._s(_vm.comp.button_2_text) + "\n                                    ")])], 1) : _vm._e()])])]], 2)], 1), _vm._v(" "), _vm._l((_vm.comp.questions), function(item, index) {
    return _c('sk-accordian', {
      key: index,
      attrs: {
        "active": "",
        "auto-expand-first": index == 0
      }
    }, [_c('template', {
      slot: "header"
    }, [_c('h4', [_vm._v(_vm._s(item.title))])]), _vm._v(" "), _c('template', {
      slot: "content"
    }, [_c('sk-panel', {
      domProps: {
        "innerHTML": _vm._s(item.body)
      }
    })], 1)], 2)
  })]], 2)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4e6c93b2","hasScoped":false}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/pages/competitions/competition.vue
// module id = 699
// module chunks = 0